import { NoResultComponent } from '@/app/components/shared/no-result/no-result.component';
import { SkeletonCompetitionWithMatchesComponent } from '@/app/components/shared/skeleton';
import { RouteValidatorService } from '@/app/services/route-validator.service';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  inject,
  viewChild,
} from '@angular/core';
import { EntityFavoriteRowComponent } from '../../components';
import { CompetitionFavoritesMatchesByDayService } from '../../services/competition-favorites-matches-by-day.service';

@Component({
  selector: 'app-my-competitions',
  standalone: true,
  imports: [
    NoResultComponent,
    SkeletonCompetitionWithMatchesComponent,
    EntityFavoriteRowComponent,
  ],
  templateUrl: './my-competitions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyCompetitionsComponent {
  private observer!: IntersectionObserver;
  private competitionFavoritesMatchesByDayService = inject(
    CompetitionFavoritesMatchesByDayService
  );

  private routeValidatorService = inject(RouteValidatorService);

  fetchStatus = computed(() => ({
    isLoading:
      this.competitionFavoritesMatchesByDayService.isLoadingSoccerMatches(),
    isError:
      this.competitionFavoritesMatchesByDayService.isErrorSoccerMatches(),
  }));

  data = computed(() => ({
    counterMatches:
      this.competitionFavoritesMatchesByDayService.counterMatches(),
    soccerMatches: this.competitionFavoritesMatchesByDayService.soccerMatches(),
    pagination:
      this.competitionFavoritesMatchesByDayService.paginationMatches(),
  }));

  scoreContainerRef = viewChild<ElementRef<HTMLDivElement>>(
    'soccerMatchesContainer'
  );
  scrollTriggerRef = viewChild<ElementRef<HTMLDivElement>>('scrollTrigger');

  constructor() {
    this.routeValidatorService.isActiveTabCompetitionFavorite.set(true);
  }

  ngAfterViewInit() {
    const refItem = this.scrollTriggerRef()?.nativeElement;

    if (!refItem) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (
            entry.isIntersecting &&
            this.competitionFavoritesMatchesByDayService.isMoreMatches() &&
            this.competitionFavoritesMatchesByDayService.soccerMatches()
              .length > 9
          ) {
            this.competitionFavoritesMatchesByDayService.getCompetitionMatchesFavorites(
              this.competitionFavoritesMatchesByDayService.paginationMatches() +
                1
            );
          }
        });
      },
      {
        root: null, // null = viewport
        rootMargin: '200px', // Se activará 200px antes de que el elemento sea visible
        threshold: 0.01,
      }
    );

    this.observer.observe(refItem);

    if (
      !this.competitionFavoritesMatchesByDayService.isLoadingSoccerMatches()
    ) {
      this.competitionFavoritesMatchesByDayService.getCompetitionMatchesFavorites();
    }

    // 👉 Primer fetch con skeleton
    if (
      !this.competitionFavoritesMatchesByDayService.isLoadingSoccerMatches()
    ) {
      this.competitionFavoritesMatchesByDayService.getCompetitionMatchesFavorites();
    }
  }

  ngOnDestroy() {
    this.competitionFavoritesMatchesByDayService.clearSoccerMatches();
    if (this.observer) {
      this.observer.disconnect();
    }

    this.routeValidatorService.isActiveTabCompetitionFavorite.set(false);
  }
}
